function initAppointmentSelector() {

	const appointmentSelectors = document.querySelectorAll(".appointment-selector");

	const isEnglish = document.documentElement.getAttribute("lang") === "en-GB";
	const days = isEnglish ? ['SUN.', 'MON.', 'TUE.', 'WED.', 'THU.', 'FRI.', 'SAT.'] : ['DIM.', 'LUN.', 'MAR.', 'MER.', 'JEU.', 'VEN.', 'SAM.'];
	const months = isEnglish ? ['JAN.', 'FEB.', 'MAR.', 'APR.', 'MAY.', 'JUN.', 'JUL.', 'AUG.', 'SEP.', 'OCT.', 'NOV.', 'DEC.'] : ['JAN.', 'FÉV.', 'MAR.', 'AVR.', 'MAI.', 'JUIN.', 'JUIL.', 'AOÛ.', 'SEP.', 'OCT.', 'NOV.', 'DÉC.'];
	let weekHours = ["7:30","8:00", "8:30", "9:00", "9:30", "10:00", "10:30", "11:00", "11:30", "12:00", "12:30", "13:00", "13:30", "14:00", "14:30", "15:00", "15:30", "16:00", "16:30", "17:00", "17:30", "18:00", "18:30", "19:00", "19:30", "20:00", "20:30", "21:00"];

	if(document.body.classList.contains('is-pure')) {
		weekHours = ["6:30","7:00","7:30","8:00", "8:30", "9:00", "9:30", "10:00", "10:30", "11:00", "11:30", "12:00", "12:30", "13:00", "13:30", "14:00", "14:30", "15:00", "15:30", "16:00", "16:30", "17:00", "17:30", "18:00", "18:30", "19:00", "19:30", "20:00", "20:30", "21:00"];
	} else if(document.body.classList.contains('is-ch')) {
		weekHours = ["7:00","7:30","8:00", "8:30", "9:00", "9:30", "10:00", "10:30", "11:00", "11:30", "12:00", "12:30", "13:00", "13:30", "14:00", "14:30", "15:00", "15:30", "16:00", "16:30", "17:00", "17:30", "18:00", "18:30", "19:00", "19:30", "20:00", "20:30", "21:00"];
	}

	// récupération des X prochains jours
	function getNextDays(nbJours) {
		let result = [];
		let date = new Date();

		for (let i = 0; i < nbJours; i++) {
			let dayNumberInWeek = date.getDay();
			let dayName = days[date.getDay()];
			let dayNumber = date.getDate();
			let monthName = months[date.getMonth()];
			let isoDate = formatDateISO(date);

			result.push({
				dayNumberInWeek,
				dayName,
				dayNumber,
				monthName,
				isoDate
			});
			date.setDate(date.getDate() + 1);
		}

		return result;
	}


	// Plusieurs sélecteurs par page
	appointmentSelectors.forEach(appointmentSelector => {
		const dates = getNextDays(15);
		const dateSelector = appointmentSelector.querySelector(".date-selector");
		const dateInput = appointmentSelector.parentElement.querySelector(`input[name="appointment_date"]`);
		const hourInput = appointmentSelector.parentElement.querySelector(`input[name="appointment_hour"]`);
		const isoDateInput = appointmentSelector.parentElement.querySelector(`input[name="appointment_date_iso"]`);

		// Construction des dates avec le jour en cours actif
		dates.forEach((date, index) => {
			const activeClass = index === 0 ? " active today" : "";
			dateSelector.insertAdjacentHTML("beforeend",
				`
						<div data-id="${index}" 
							 data-day-number-in-week="${date.dayNumberInWeek}"
							 data-iso-date="${date.isoDate}" 
							 class="date${activeClass}">
							<div class="day">${date.dayName}</div>
							<div class="number">${date.dayNumber}</div>
							<div class="month">${date.monthName}</div>
						</div>
						`
			);
			const currentDay = dateSelector.querySelector(`[data-id="${index}"]`);
			if (index === 0) {
				appointmentSelector.currentSelected = currentDay;
				appointmentSelector.setAttribute("data-current-day", date.dayNumberInWeek);
			}
			// Changement de jour + maj des heures dispo
			currentDay.addEventListener("click", () => {
				appointmentSelector.currentSelected.classList.remove("active");
				currentDay.classList.add("active");
				appointmentSelector.currentSelected = currentDay;
				updateAvailableHours(appointmentSelector, dateInput, hourInput);
				appointmentSelector.setAttribute("data-current-day", date.dayNumberInWeek);
			});

			// Après avoir ajouté tous les jours
			markDisabledDays(appointmentSelector);
		});

		let responsive = [
			{breakpoint: 1400, settings: {slidesToShow: 8, slidesToScroll: 8}},
			{breakpoint: 1200, settings: {slidesToShow: 7, slidesToScroll: 7}},
			{breakpoint: 900, settings: {slidesToShow: 6, slidesToScroll: 6}},
			{breakpoint: 768, settings: {slidesToShow: 8, slidesToScroll: 8}},
			{breakpoint: 600, settings: {slidesToShow: 7, slidesToScroll: 7}},
			{breakpoint: 450, settings: {slidesToShow: 6, slidesToScroll: 6}},
			{breakpoint: 400, settings: {slidesToShow: 5, slidesToScroll: 5}},
			{breakpoint: 300, settings: {slidesToShow: 3, slidesToScroll: 3}},
			{breakpoint: 250, settings: {slidesToShow: 2, slidesToScroll: 2}},
			{breakpoint: 200, settings: {slidesToShow: 1, slidesToScroll: 1}}
		];
		if (document.body.classList.contains("single-landing-standalone") || document.body.classList.contains("single-activity")) {
			responsive = [
				{breakpoint: 1200, settings: {slidesToShow: 6, slidesToScroll: 6}},
				{breakpoint: 1100, settings: {slidesToShow: 5, slidesToScroll: 5}},
				{breakpoint: 992, settings: {slidesToShow: 6, slidesToScroll: 6}},
				{breakpoint: 768, settings: {slidesToShow: 7, slidesToScroll: 7}},
				{breakpoint: 600, settings: {slidesToShow: 6, slidesToScroll: 6}},
				{breakpoint: 450, settings: {slidesToShow: 5, slidesToScroll: 5}},
				{breakpoint: 400, settings: {slidesToShow: 4, slidesToScroll: 4}},
				{breakpoint: 350, settings: {slidesToShow: 3, slidesToScroll: 3}},
				{breakpoint: 300, settings: {slidesToShow: 2, slidesToScroll: 2}},
				{breakpoint: 200, settings: {slidesToShow: 1, slidesToScroll: 1}}
			];
		}

		// Slider de date responsive
		$(dateSelector).slick({
			autoplay: false,
			slidesToShow: 7,
			slidesToScroll: 7,
			spaceBetween: 5,
			infinite: false,
			arrows: true,
			swipe: true,
			dots: false,
			fade: false,
			adaptiveHeight: false,
			responsive: responsive
		});

		// Construction du selecteur d'heure
		const hourSelector = appointmentSelector.querySelector(".hour-selector");
		weekHours.forEach((hour, index) => {
			const activeClass = index === 0 ? " active" : "";
			const hourOfDay = parseInt(hour.split(":")[0]);
			const minutes = parseInt(hour.split(":")[1]);
			let availableClass = "";
			if (index < 2 || index > 22) {
				availableClass = "week";
			} else {
				if (index < 17) {
					availableClass = "week saturday sunday";
				} else if (index < 23) {
					availableClass = "week saturday";
				}
			}
			hourSelector.insertAdjacentHTML("beforeend", `
				<div class="hour${activeClass} ${availableClass}" 
				data-id="${index}"
				data-hour-of-day="${hourOfDay}"
				data-minutes="${minutes}"
				>${hour}</div>
				`);
			const currentHour = hourSelector.querySelector(`[data-id="${index}"]`);
			if (index === 0) {
				hourSelector.currentSelected = currentHour;
				hourInput.value = currentHour.innerText;
				hourInput.setAttribute("value", currentHour.innerText);

				const isoDate = appointmentSelector.currentSelected.dataset.isoDate;
				const isoDateTime = isoDate + " " + currentHour.innerText + ":00";
				dateInput.value = isoDate;
				dateInput.setAttribute("value", isoDate);
				isoDateInput.value = isoDateTime;
				isoDateInput.setAttribute("value", isoDateTime);
			}
			currentHour.addEventListener("click", () => {
				hourSelector.currentSelected.classList.remove("active");
				currentHour.classList.add("active");
				hourSelector.currentSelected = currentHour;
				hourInput.value = currentHour.innerText;
				hourInput.setAttribute("value", currentHour.innerText);

				const isoDate = appointmentSelector.currentSelected.dataset.isoDate;
				const isoDateTime = isoDate + " " + currentHour.innerText + ":00";
				dateInput.value = isoDate;
				dateInput.setAttribute("value", isoDate);
				isoDateInput.value = isoDateTime;
				isoDateInput.setAttribute("value", isoDateTime);
			});
		});

		// Affichage masquage du selecteur en fonction du choix RDV/Rapper
		const appointmentInput = appointmentSelector.previousElementSibling.querySelector(`input[value="appointment"]`);
		const callbackInput = appointmentSelector.previousElementSibling.querySelector(`input[value="callback"]`);
		appointmentInput.addEventListener("change", () => {
			appointmentSelector.classList.remove("d-none");
			$(dateSelector).slick("refresh");
			appointmentSelector.querySelector(".date.today").click();
		});
		callbackInput.addEventListener("change", () => {
			appointmentSelector.classList.add("d-none");
			dateInput.value = "";
			dateInput.setAttribute("value", "");
			hourInput.value = "";
			hourInput.setAttribute("value", "");
			isoDateInput.value = "";
			isoDateInput.setAttribute("value", "");
			appointmentSelector.currentSelected.classList.remove("active");
			hourSelector.currentSelected.classList.remove("active");
		});

		// Mise à jour des heures dispo du jour en cours
		updateAvailableHours(appointmentSelector, dateInput, hourInput);
	});

}

function updateAvailableHours(selector, dateInput, hourInput) {
	const hours = selector.querySelectorAll(".hour");
	const date = selector.querySelector(".date.active");

	if (!date){
		return;
	}

	const clubSelect = selector.closest("form").querySelector(`[name="club-list"]`);
	if (!clubSelect) return;

	// Mise à jour du calendrier en cours au choix du club
	if(!clubSelect.changeInitialized){
		clubSelect.changeInitialized = true;
		// Jquery à cause du .change() dans le forms.js qui trigger que le change jquery
		$(clubSelect).on("change", ()=>{
			updateAvailableHours(selector, dateInput, hourInput);
			markDisabledDays(selector);
		});
	}

	const selectedClub = clubSelect.value;
	const globalConfig = window.calendar;

	const dayOfWeek = date.dataset.dayNumberInWeek;
	const formattedDate = date.dataset.isoDate; // Assurez-vous que la date est au format YYYY-MM-DD

	const clubConfig = globalConfig[selectedClub];
	if (!clubConfig) return;

	let opening, closing;

	// === GESTION DES EXCEPTIONS ===
	if (clubConfig.exceptions && clubConfig.exceptions[formattedDate] !== undefined) {
		const exception = clubConfig.exceptions[formattedDate];

		if (!exception.open) {
			hours.forEach(hour => hour.classList.remove("available"));
			return;
		}

		// Si des horaires personnalisés sont définis pour cette date, on les utilise
		if (exception.opening && exception.closing) {
			opening = exception.opening;
			closing = exception.closing;
		}
	}

	// === HORAIRES PAR DÉFAUT si pas d'exception horaire ===
	if (!opening || !closing) {
		const defaultConfig = clubConfig.default[dayOfWeek];
		if (!defaultConfig || !defaultConfig.open) {
			hours.forEach(hour => hour.classList.remove("available"));
			return;
		}
		opening = defaultConfig.opening;
		closing = defaultConfig.closing;
	}

	// === Conversion en minutes ===
	const [openingHours, openingMinutes] = opening.split(":").map(Number);
	const [closingHours, closingMinutes] = closing.split(":").map(Number);
	const openingTimeInMinutes = openingHours * 60 + openingMinutes;
	const closingTimeInMinutes = closingHours * 60 + closingMinutes;

	// === Boucle de mise à jour des créneaux ===
	hours.forEach(hour => {
		const hourOfDay = parseInt(hour.dataset.hourOfDay);     // ex: 9
		const minuteOfDay = parseInt(hour.dataset.minutes);     // ex: 30
		const totalMinutes = hourOfDay * 60 + minuteOfDay;

		if (totalMinutes >= openingTimeInMinutes && totalMinutes <= closingTimeInMinutes) {
			hour.classList.add("available");
		} else {
			hour.classList.remove("available");
			if (hour.classList.contains("active")) {
				hour.classList.remove("active");
				hourInput.value = "";
				hourInput.setAttribute("value", "");
			}
		}
	});

	// Vérification si la date est aujourd'hui et suppression des heures passées
	if (date.classList.contains("today")) {
		const now = new Date();
		const currentHour = now.getHours();
		const currentMinutes = now.getMinutes();
		hours.forEach(hour => {
			const hourOfDay = parseInt(hour.dataset.hourOfDay);
			if (hourOfDay <= currentHour + 1) {
				if (hourOfDay === currentHour + 1 && hour.dataset.minutes >= currentMinutes) {
					return;
				}
				hour.classList.remove("available");
				if (hour.classList.contains("active")) {
					hour.classList.remove("active");
					hourInput.value = "";
					hourInput.setAttribute("value", "");
				}
			}
		});
	}
}

function markDisabledDays(selector) {
	const dateElements = selector.querySelectorAll(".date");
	const clubSelect = selector.closest("form").querySelector(`[name="club-list"]`);
	if (!clubSelect) return;

	const selectedClub = clubSelect.value;
	const globalConfig = window.calendar;
	const clubConfig = globalConfig[selectedClub];
	if (!clubConfig) return;

	dateElements.forEach(dateEl => {
		const dayOfWeek = dateEl.dataset.dayNumberInWeek;
		const formattedDate = dateEl.dataset.isoDate;

		let isOpen = false;

		// Vérifier exceptions
		if (clubConfig.exceptions && clubConfig.exceptions[formattedDate] !== undefined) {
			if (!clubConfig.exceptions[formattedDate].open) {
				dateEl.classList.add("disabled");
				return;
			} else {
				isOpen = true;
			}
		}

		// Sinon, on regarde les horaires par défaut
		const defaultConfig = clubConfig.default[dayOfWeek];
		if (!defaultConfig || !defaultConfig.open) {
			dateEl.classList.add("disabled");
			return;
		}

		// S'il y a une config d'ouverture, vérifier s'il y a des heures disponibles
		// Todo: plus forcement ok du fait qu'on gere differement le cas classique
		const openingHour = parseInt(defaultConfig.opening.split(":")[0]);
		const closingHour = parseInt(defaultConfig.closing.split(":")[0]);

		// Filtrer les heures possibles pour ce jour
		const hasAvailableHour = Array.from(selector.querySelectorAll(".hour")).some(hour => {
			const hourOfDay = parseInt(hour.dataset.hourOfDay);
			return hourOfDay >= openingHour && hourOfDay < closingHour;
		});

		if (!hasAvailableHour) {
			dateEl.classList.add("disabled");
		} else {
			dateEl.classList.remove("disabled");
		}
	});
}

function formatDateISO(date) {
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, '0'); // Mois commence à 0, donc on ajoute 1
	const day = String(date.getDate()).padStart(2, '0');
	return `${year}-${month}-${day}`;
}

